import React, { useEffect } from "react";
import { Row, Col, InputGroup } from "react-bootstrap";
import "../../../theme/css/Contactus.css";
import "../../../theme/css/Assortimento.css";

export default function Assortimento() {
    function increaseNumberAnimation(elementId, endNumber, speed = 10) {
        const element = document.getElementById(elementId)
        if (!element) return
        const animationDone = JSON.parse(element.dataset.animationDone ?? false)
        if (animationDone) return
        const animationRunning = JSON.parse(element.dataset.animationRunning ?? false)
        if (animationRunning) return
        element.dataset.animationRunning = true
        incNbrRec(0, endNumber, element, speed)
    }

    function incNbrRec(currentNumber, endNumber, element, speed) {
        if (currentNumber <= endNumber) {
            element.innerHTML = ('000' + currentNumber).slice(-3)
            setTimeout(function () {
                incNbrRec(currentNumber + 1, endNumber, element, speed)
            }, speed)
        } else {
            element.dataset.animationRunning = false
            element.dataset.animationDone = true
        }
    }

    useEffect(() => {
        // Crea intersection observer
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const elementId = entry.target.id;
                    const animationDone = JSON.parse(entry.target.dataset.animationDone ?? false)
                    if (animationDone) return
                    if (elementId === 'nbevande') {
                        increaseNumberAnimation('nbevande', 500);
                    } else if (elementId === 'nsurgelati') {
                        increaseNumberAnimation('nsurgelati', 400);
                    } else if (elementId === 'nfreschi') {
                        increaseNumberAnimation('nfreschi', 200);
                    }

                    // Avvia una sola volta: dopo il primo trigger smetti di osservare
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.1 // Attiva quando almeno il 10% dell'elemento è visibile
        });

        // Osserva tutti gli elementi contatore
        const elements = ['nbevande', 'nsurgelati', 'nfreschi'];
        elements.forEach(id => {
            const element = document.getElementById(id);
            if (element) {
                observer.observe(element);
            }
        });

        // Pulisce l'observer quando il componente viene smontato
        return () => {
            elements.forEach(id => {
                const element = document.getElementById(id);
                if (element) {
                    observer.unobserve(element);
                }
            });
        };
    }, []);

    return (
        <div className="container" id='assortimento'>
            <div className="startToday spacing">
                <div className="titleFont text-center" data-aos="fade-up">
                    <h2>Assortimento</h2>
                </div>
            </div>
            <div className="contactContain assortimento-cards">
                <Row data-aos="flip-down" className="assortimento-row">
                    <Col lg={4} xl={4}>
                        <div className="contactIconBgShadow text-center">
                            <h1 id='nbevande'>000</h1>
                            <h2>BEVANDE</h2>
                        </div>
                    </Col>
                    <Col lg={4} xl={4}>
                        <div className="contactIconBgShadow text-center">
                            <h1 id='nsurgelati'>000</h1>
                            <h2>SURGELATI</h2>
                        </div>
                    </Col>
                    <Col lg={4} xl={4}>
                        <div className="contactIconBgShadow text-center">
                            <h1 id='nfreschi'>000</h1>
                            <h2>FRESCHI</h2>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
}
